/**
 * @param {URLSearchParams} searchParams
 * @returns {string|undefined}
 */
export function findAllerId(searchParams) {
	for (const paramKey of searchParams.keys()) {
		if (paramKey.toLowerCase() === 'allerid') {
			const allerId = searchParams.get(paramKey);
			if (allerId) return allerId;
		}
	}
}
